import { inject, Injectable, Injector } from '@angular/core';
import { OutgoingEventsSenderService } from './outgoing-events/outgoing-events-sender.service';

@Injectable({ providedIn: 'root' })
export class OutgoingEventsHandlerService {
  private readonly injector = inject(Injector);
  private readonly sender = inject(OutgoingEventsSenderService);

  public register(): void {
    this.sender.register();
  }
}
